import { DocxArtifactPreview } from './docx-artifact-preview';
import { HtmlArtifactPreview } from './html-artifact-preview';
import { PdfArtifactPreview } from './pdf-artifact-preview';
import { PptxArtifactPreview } from './pptx-artifact-preview';
import { PreviewError } from './preview-state';
import { TextArtifactPreview } from './text-artifact-preview';
import type { ArtifactPreview } from './types';
import { XlsxArtifactPreview } from './xlsx-artifact-preview';

export function ArtifactPreviewContent({
  fileUrl,
  fitToPaneRequestId,
  onClose,
  onUserZoomChange,
  preview,
}: {
  fileUrl: string;
  fitToPaneRequestId: number;
  onClose: () => void;
  onUserZoomChange: () => void;
  preview: ArtifactPreview;
}) {
  if (preview.fileType === 'docx') {
    return (
      <DocxArtifactPreview
        fileUrl={fileUrl}
        fitToPaneRequestId={fitToPaneRequestId}
        onClose={onClose}
        onUserZoomChange={onUserZoomChange}
        sourceUrl={preview.sourceUrl}
        title={preview.title}
      />
    );
  }

  if (preview.fileType === 'html') {
    return <HtmlArtifactPreview key={preview.sourceUrl} sourceUrl={preview.sourceUrl} title={preview.title} />;
  }

  if (preview.fileType === 'pdf') {
    return (
      <PdfArtifactPreview
        fileUrl={fileUrl}
        fitToPaneRequestId={fitToPaneRequestId}
        onClose={onClose}
        onUserZoomChange={onUserZoomChange}
        sourceUrl={preview.sourceUrl}
        title={preview.title}
      />
    );
  }

  if (preview.fileType === 'pptx') {
    return <PptxArtifactPreview sourceUrl={preview.sourceUrl} title={preview.title} />;
  }

  if (preview.fileType === 'txt') {
    return <TextArtifactPreview sourceUrl={preview.sourceUrl} title={preview.title} />;
  }

  if (preview.fileType === 'xlsx') {
    return <XlsxArtifactPreview sourceUrl={preview.sourceUrl} title={preview.title} />;
  }

  return <PreviewError message="Unsupported preview type." />;
}
